<div>
  <form [formGroup]="formGroup" class="flex flex-column gap-4 mb-4">
    <div class="flex flex-column gap-2">
      <label for="name" class="font-medium">Nom <span class="text-red-500">*</span></label>
      <input pInputText id="name" aria-describedby="name-help" formControlName="name"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('name')}" />
      <small *ngIf="!hasFieldError('name')" id="name-help" class="text-gray-600">
        Nom du groupe (3-100 caractères).
      </small>
      <small *ngIf="hasFieldError('name')" class="text-red-500">
        {{ getFieldError('name') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="institution" class="font-medium">Institution <span class="text-red-500">*</span></label>
      <input pInputText id="institution" aria-describedby="institution-help"
             [value]="boundData?.data?.institution?.name || ''"
             [disabled]="true"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('institution')}" />
      <small *ngIf="!hasFieldError('institution')" id="institution-help" class="text-gray-600">
        Institution associée au groupe.
      </small>
      <small *ngIf="hasFieldError('institution')" class="text-red-500">
        {{ getFieldError('institution') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="desc" class="font-medium">Description <span class="text-red-500">*</span></label>
      <textarea id="desc" rows="5" cols="30" pTextarea formControlName="description"
                [ngClass]="{'ng-invalid ng-dirty': hasFieldError('description')}"
                placeholder="Description du groupe..."></textarea>
      <small *ngIf="!hasFieldError('description')" class="text-gray-600">
        Description du groupe (10-500 caractères).
      </small>
      <small *ngIf="hasFieldError('description')" class="text-red-500">
        {{ getFieldError('description') }}
      </small>
    </div>
  </form>
  <p-accordion class="mt-2" [multiple]="true" [value]="['0']">
    <p-accordion-panel class="mb-2" value="0">
      <p-accordion-header>Permissions</p-accordion-header>
      <p-accordion-content>
        <group-permissions [selectedPermissions]="permissions" (permissionsChange)="permissionChange($event)"></group-permissions>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel class="mb-2" value="1">
      <p-accordion-header>Utilisateurs</p-accordion-header>
      <p-accordion-content>
        <dynamic-table [data]="users" [headers]="userCols" [pageParams]="pageable" (paginate)="onPageChange($event)"></dynamic-table>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
